import urls from "../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../utils/service";

export async function getViewPerosnalDetails(userId: String) {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GETEMPLOYEERECORDBYID + userId,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }